import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// 解决 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

// 首页改为懒加载（原来直接导入）
const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/home/index.vue"),
  },
  // 移除重复的 /home 路由，避免重复加载
  // {
  //   path: "/home",
  //   name: "home",
  //   component: HomeView,
  // },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/about/index.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("@/views/product/index.vue"),
  },
  {
    path: "/case",
    name: "case",
    component: () => import("@/views/case/index.vue"),
  },
  {
    path: "/info",
    name: "info",
    component: () => import("@/views/info/index.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/detail/index.vue"),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 };
  },
});

export default router;